module.exports = __webpack_public_path__ + "static/media/DKS-319.cfcd8082.png";